import React, {useEffect, useState} from 'react';
import '../less/App.css';
import Header from "./Header";
import Body from "./Body";
import {HashRouter as Router} from "react-router-dom";
import {DataBaseHandler} from "../logic/db/DataBaseHandler";

const handler = DataBaseHandler.instance()

function App() {

    const [dbLoaded, setDbLoaded] = useState(false)
    const [dbError, setDBError] = useState(false)

    useEffect(() => {
        handler.init().then(() => {
            setDbLoaded(true)
        }).catch(() => {
            setDBError(true)
        })
        return () => { DataBaseHandler.instance().closeDB()}
    }, [setDBError, setDbLoaded])

    //TODO: add Error page for failing db load
    return ( dbLoaded ?
        <div className="app">
            <Router>
                <Header/>
                <Body/>
            </Router>
        </div> : dbError ? null : null
    );
}

export default App;
